/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable multiline-ternary */
import Phrase from '../../libs/translationsUtils/phrase'
import { TranslationCategory } from '../../libs/translationsUtils/translations'
import { ComponentChild } from 'preact'
import tracker from '../../components/tracker/publish'
import { CurrentPageContext } from '../../pages/utils'
import classnames from 'classnames'
import { z } from 'zod'

const eventTracker = (_: unknown, title: string, url: string, type: string) => {
  if (!['parent category', 'category'].includes(type)) {
    return
  }

  tracker.trackEvent('userevent', {
    type: 'Category Clicked',
    category_title: title,
    category_url: url,
    category_type: type,
    click_source: 'breadcrumb'
  })
}

interface TitleWrapperParams {
  url: string | null
  title: string
  type: string
  children: ComponentChild
}

const TitleWrapper = ({ url, title, type, children }: TitleWrapperParams) => {
  if (url) {
    return (
      <a className='breadcrumb-item-link' href={url} onClick={(e) => eventTracker(e, title, url, type)}>
        {children}
      </a>
    )
  } else {
    return <span className='current'>{children}</span>
  }
}

const types = ['homepage', 'parent category', 'category']
const qaClasses = ['qa-breadcrumb-community', 'qa-breadcrumb-category', 'qa-breadcrumb-forum', 'qa-breadcrumb-topic']

function isWithPhrase(p: PhraseProp): p is BreadcrumbWithPhrase {
  return 'phrase' in p
}

interface BreadcrumbWithPhrase {
  phrase: [TranslationCategory, string]
  url: string
}

interface PhraseUrl {
  title: string
  url: string
}

type PhraseProp = BreadcrumbWithPhrase | PhraseUrl

interface Props {
  breadcrumbData?: PhraseProp[]
}

export const widgetName = 'breadcrumb'

export const config = z.undefined()

const Breadcrumb = ({ breadcrumbData }: Props) => {
  return (
    <CurrentPageContext.Consumer>
      {(pageContext: { breadcrumbs: any }) => {
        const breadcrumbs = breadcrumbData || pageContext.breadcrumbs
        if (!breadcrumbs || !breadcrumbs.length) return null

        return (
          <div className='sitewidth breadcrumb-container'>
            <div className={classnames('col', 'main-navigation--breadcrumb-wrapper', 'widget--breadcrumb')}>
              <ul className='breadcrumb'>
                {breadcrumbs.map((data: PhraseProp, index: number) => (
                  <li key={index} className={`breadcrumb-item ${qaClasses[index]}`}>
                    {isWithPhrase(data) ? (
                      <Phrase m={data.phrase[0]} p={data.phrase[1]}>
                        {(title) => (
                          <TitleWrapper
                            url={breadcrumbs.length > index + 1 ? data.url : null}
                            title={title}
                            type={types[index]}
                          >
                            <i className={classnames('icon', 'icon--caret-left', 'is-visible-S')} />
                            {title}
                          </TitleWrapper>
                        )}
                      </Phrase>
                    ) : (
                      <TitleWrapper
                        url={breadcrumbs.length > index + 1 ? data.url : null}
                        title={data.title}
                        type={types[index]}
                      >
                        <i className={classnames('icon', 'icon--caret-left', 'is-visible-S')} />
                        {data.title}
                      </TitleWrapper>
                    )}
                    <i className='icon icon--caret-right' />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )
      }}
    </CurrentPageContext.Consumer>
  )
}

export { TitleWrapper }
export default Breadcrumb
